export const Bet_Types = Object.freeze ({
    Pending: 0,
    Completed: 1
})